import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { ChildrenSchema } from 'utils'

import HorizontalScroll from '../HorizontalScroll'
import SimpleButton from '../SimpleButton'
import HeaderImage from './HeaderImage'

import styles from './index.css'

class Tour extends PureComponent {
  render() {
    const { children, onSkip } = this.props

    return (
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <HeaderImage className={styles.headerImage} />
        </div>
        <div className={styles.header}>
          <SimpleButton ariaLabel="Saltar tour" className={styles.headerButton} onClick={onSkip}>
            {' '}
            Saltar
          </SimpleButton>
        </div>
        <HorizontalScroll>{children}</HorizontalScroll>
      </div>
    )
  }
}

Tour.propTypes = {
  children: ChildrenSchema.isRequired,
  onSkip: PropTypes.func.isRequired,
}

export default Tour
